<div class="content">
  <div class="content-panel">
    <h2 translate>page.controles.controles.title</h2>

  <form [formGroup]="formSearchControles" #form="ngForm" (ngSubmit)="onSubmit()" class="search-form">
    <div class="card shadow-sm border-0 mb-3">
      <div class="card-body py-3">
        <div class="row g-3 align-items-end">

          <div class="col-12 col-lg-4">
            <label for="nature" class="form-label" translate>
              page.controles.controles.search.nature
            </label>
            <select id="nature" formControlName="nature" class="form-select" (change)="changeNature()" [ngClass]="{'is-invalid': form.submitted && nature.invalid}">
              <option [ngValue]="null">Sélectionner</option>
              <option *ngFor="let nature of refNatures" [ngValue]="nature.id">
                {{ nature.libelle }}
              </option>
            </select>
          </div>

          <div class="col-12 col-lg-4" *ngIf="estFiltreOrganoleptique">
            <label for="commission" class="form-label" translate>
              page.controles.controles.search.numeroCommission
            </label>
            <select id="commission" formControlName="numeroCommission" class="form-select" [ngClass]="{'is-invalid': form.submitted && numeroCommission.invalid}">
              <option [ngValue]="null">Toutes</option>
              <ng-container *ngFor="let commission of commissions">
                <option [ngValue]="commission">
                  {{ commission.dateDebut | date:'dd/MM/yyyy' }} ({{ commission.numero }})
                </option>
              </ng-container>
            </select>
          </div>

          <div class="col-12 col-lg-4 d-flex gap-2">
            <button
              type="button"
              class="btn btn-outline-secondary w-100"
              (click)="showAdvancedFilters = !showAdvancedFilters"
            >
              {{ showAdvancedFilters ? 'Masquer les filtres' : 'Filtres avancés' }}
            </button>

            <button
              type="submit"
              class="btn btn-primary w-100"
              *hasRole="'DECLARATION_CONTROLE_LECTURE'"
            >
              Rechercher
            </button>
          </div>
        </div>
      </div>
      <div class="active-filters mt-3" *ngIf="hasActiveFilters()">

        <span class="badge text-bg-light border me-2 mb-2" *ngIf="formSearchControles.get('types')?.value?.length">
          Types : {{ getLibelles(formSearchControles.get('types')?.value, 'libelle') }}
        </span>

        <span class="badge text-bg-light border me-2 mb-2" *ngIf="formSearchControles.get('statuts')?.value?.length">
          Statuts : {{ getLibelles(formSearchControles.get('statuts')?.value, 'libelle') }}
        </span>

        <span class="badge text-bg-light border me-2 mb-2" *ngIf="formSearchControles.get('cahier')?.value?.length">
          CDC : {{ getLibelles(formSearchControles.get('cahier')?.value, 'libelle') }}
        </span>

        <span class="badge text-bg-light border me-2 mb-2" *ngIf="formSearchControles.get('agents')?.value?.length">
          Agents : {{ getLibelles(formSearchControles.get('agents')?.value, 'nomComplet') }}
        </span>

        <span class="badge text-bg-light border me-2 mb-2" *ngIf="formSearchControles.get('laboratoires')?.value?.length">
          Laboratoires : {{ getLibelles(formSearchControles.get('laboratoires')?.value, 'libelle') }}
        </span>

        <span class="badge text-bg-light border me-2 mb-2" *ngIf="formSearchControles.get('numeroEchantillon')?.value">
          Échantillon : {{ formSearchControles.get('numeroEchantillon')?.value }}
        </span>

        <span class="badge text-bg-light border me-2 mb-2" *ngIf="formSearchControles.get('numeroCVI')?.value">
          CVI : {{ formSearchControles.get('numeroCVI')?.value }}
        </span>

        <span class="badge text-bg-light border me-2 mb-2" *ngIf="formSearchControles.get('debutDateControle')?.value">
          Date début renseignée
        </span>

        <span class="badge text-bg-light border me-2 mb-2" *ngIf="formSearchControles.get('finDateControle')?.value">
          Date fin renseignée
        </span>
      </div>
    </div>

    <div *ngIf="showAdvancedFilters && (estFiltreOrganoleptique || estFiltreAnalytique)">
      <div class="card shadow-sm border-0 mb-3">
        <div class="card-body py-3">
          <div class="row g-3">

            <div class="col-12 col-md-6 col-xl-3">
              <label for="types" class="form-label" translate>
                page.controles.controles.search.type
              </label>
              <app-multiselect
                id="types"
                controlName="types"
                [items]="refTypes"
                bindLabel="libelle"
                maxWidth="initial">
              </app-multiselect>
            </div>

            <div class="col-12 col-md-6 col-xl-3">
              <label for="statuts" class="form-label" translate>
                page.controles.controles.search.statut
              </label>
              <app-multiselect
                id="statuts"
                controlName="statuts"
                [items]="refStatuts"
                bindLabel="libelle"
                maxWidth="initial">
              </app-multiselect>
            </div>

            <div class="col-12 col-md-6 col-xl-3">
              <label for="debutDateControle" class="form-label" translate>
                page.controles.controles.search.dateControleEntre
              </label>
              <div class="input-group">
                <input
                  id="debutDateControle"
                  ngbDatepicker
                  #debutDatepickerControle="ngbDatepicker"
                  formControlName="debutDateControle"
                  class="form-control"
                />
                <button type="button" (click)="debutDatepickerControle.toggle()" class="btn btn-outline-secondary">
                  <fa-icon icon="calendar-alt"></fa-icon>
                </button>
              </div>
            </div>

            <div class="col-12 col-md-6 col-xl-3">
              <label for="finDateControle" class="form-label" translate>
                page.controles.controles.search.et
              </label>
              <div class="input-group">
                <input
                  id="finDateControle"
                  ngbDatepicker
                  #finDatepickerControle="ngbDatepicker"
                  formControlName="finDateControle"
                  class="form-control"
                />
                <button type="button" (click)="finDatepickerControle.toggle()" class="btn btn-outline-secondary">
                  <fa-icon icon="calendar-alt"></fa-icon>
                </button>
              </div>
            </div>

            <div class="col-12 col-md-6 col-xl-3">
              <label for="cdc" class="form-label" translate>
                page.controles.controles.search.cdc
              </label>
              <app-multiselect
                id="cdc"
                controlName="cahier"
                [items]="cahiers"
                bindLabel="libelle"
                maxWidth="initial"
                dropdownPosition="top">
              </app-multiselect>
            </div>

            <div class="col-12 col-md-6 col-xl-3">
              <label for="agents" class="form-label" translate>
                page.controles.controles.search.agent
              </label>
              <app-multiselect
                id="agents"
                controlName="agents"
                [items]="animateurs"
                bindLabel="nomComplet"
                maxWidth="initial"
                dropdownPosition="top">
              </app-multiselect>
            </div>

            <div class="col-12 col-md-6 col-xl-3">
              <label class="form-label" translate>
                page.controles.controles.search.numeroEchantillon
              </label>
              <input type="text" formControlName="numeroEchantillon" class="form-control" />
            </div>

            <div class="col-12 col-md-6 col-xl-3">
              <label class="form-label" translate>
                page.controles.controles.search.numeroCVI
              </label>
              <input type="text" formControlName="numeroCVI" class="form-control" />
            </div>

            <div class="col-12 col-md-6 col-xl-3" *ngIf="estFiltreAnalytique">
              <label for="laboratoires" class="form-label" translate>
                page.controles.controles.search.laboratoire
              </label>
              <app-multiselect
                id="laboratoires"
                controlName="laboratoires"
                [items]="refLaboratoires"
                bindLabel="libelle"
                maxWidth="initial"
                dropdownPosition="top">
              </app-multiselect>
            </div>

          </div>
        </div>
      </div>
    </div>
  </form>

  <div class="mb-3" *ngIf="estRechercheOrganoleptique && isResultat && controles?.length > 0">
    <button
      type="button"
      class="btn btn-primary"
      (click)="telechargerDocument()"
      translate
    >
      page.commissions.edit.telechargerDocuments
    </button>
  </div>

    <ng-container *hasRole="'DECLARATION_CONTROLE_LECTURE'; else aucunDroits">
      <table class="table" aria-label="Liste des contrôles" *ngIf="controles?.length > 0">
        <thead>
          <th translate>page.controles.controles.table.numeroControle</th>
          <th translate>page.controles.controles.table.raisonSociale</th>
          <th translate *ngIf="estRechercheAnalytique">page.controles.controles.table.type</th>
          <th translate>page.controles.controles.table.dateControle</th>
          <th translate *ngIf="estRechercheOrganoleptique">page.controles.controles.table.logt_lot</th>
          <th translate *ngIf="estRechercheOrganoleptique">page.controles.controles.table.volume</th>
          <th translate *ngIf="estRechercheAnalytique">page.controles.controles.table.agent</th>
          <th translate>page.controles.controles.table.produit</th>
          <th translate *ngIf="!estRechercheOrganoleptique">page.controles.controles.table.activite</th>
          <th translate *ngIf="estRechercheOrganoleptique || estRechercheAnalytique">
            page.controles.controles.table.numeroEchantillon</th>
          <th translate *ngIf="estRechercheOrganoleptique">page.controles.controles.table.numeroCommission</th>
          <th translate *ngIf="estRechercheOrganoleptique">page.controles.controles.table.numeroAnonymat</th>
          <th translate *ngIf="estRechercheAnalytique">page.controles.controles.table.laboratoire</th>
          <th translate *ngIf="estRechercheAnalytique">page.controles.controles.table.dateEnvoiLaboratoire</th>
          <th translate>page.controles.controles.table.resultat</th>
          <th></th>
        </thead>
        <tbody>
          <tr *ngFor="let controle of controles">
            <!-- Colonne N° contrôle -->
            <td>{{ controle.numeroControle || '-' }}</td>

            <!-- Colonne Raison sociale / CVI -->
            <ng-container *ngIf="controle.isLeurre; else nonLeurreRaisonSociale">
              <td><strong>{{ controle.raisonSociale }}</strong></td>
            </ng-container>
            <ng-template #nonLeurreRaisonSociale>
              <td>{{ controle.operateur?.raisonSociale }}<br/>{{ getCVI(controle) }}</td>
            </ng-template>

            <!-- Colonne Type -->
            <td *ngIf="estRechercheAnalytique">{{ controle.typeControle?.libelle }}</td>

            <!-- Colonne Date controle -->
            <ng-container *ngIf="controle.isLeurre; else nonLeurreDateControle">
              <td><strong>{{ controle.dateControle | date:'dd/MM/yyyy' }}</strong></td>
            </ng-container>
            <ng-template #nonLeurreDateControle>
              <td>{{ controle.dateControle | date:'dd/MM/yyyy' }}</td>
            </ng-template>

            <!-- Colonne Logt/lot -->
            <ng-container *ngIf="controle.isLeurre; else nonLeurreLogtLot">
              <td>-</td>
            </ng-container>
            <ng-template #nonLeurreLogtLot>
              <td *ngIf="estRechercheOrganoleptique"> {{ controle.logement }}<br>{{ controle.lot }}</td>
            </ng-template>

            <!-- Colonne Volume -->
            <td *ngIf="estRechercheOrganoleptique">{{ controle.volume || '-' }}</td>

            <!-- Colonne Agent -->
            <td *ngIf="estRechercheAnalytique">{{ getNomAgent(controle) }}</td>

            <!-- Colonne Produit -->
            <ng-container *ngIf="controle.isLeurre; else nonLeurreProduit">
              <td><strong>{{ controle.libelleProduit }}</strong></td>
            </ng-container>
            <ng-template #nonLeurreProduit>
              <td>{{ getLibelleProduit(controle) ? getLibelleProduit(controle)[0] : '' }}
                <fa-icon icon="ellipsis-h" *ngIf="getLibelleProduit(controle).length>1" [ngbTooltip]="listeProduit">
                </fa-icon>
              </td>
            </ng-template>

            <!-- Colonne Activité -->
            <td *ngIf="!estRechercheOrganoleptique">{{ getLibelleActivite(controle) }}</td>

            <!-- Colonne N° échantillon -->
            <td *ngIf="estRechercheOrganoleptique || estRechercheAnalytique">{{ controle.numeroEchantillon || '-' }}</td>

            <!-- Colonne N° commission / N° jury -->
            <ng-container *ngIf="controle.isLeurre; else nonLeurreCommission">
              <td *ngIf="estRechercheOrganoleptique"><strong>{{ controle.numeroCommission}} <br/>{{ controle.numeroJury}}</strong></td>
            </ng-container>
            <ng-template #nonLeurreCommission>
              <td *ngIf="estRechercheOrganoleptique">{{ controle.numeroCommission}} <br/>{{ controle.numeroJury}}</td>
            </ng-template>

            <!-- Colonne N° anonymat -->
            <ng-container *ngIf="controle.isLeurre; else nonLeurreAnonymat">
              <td *ngIf="estRechercheOrganoleptique"><strong>{{ controle.numeroAnonymat}}</strong></td>
            </ng-container>
            <ng-template #nonLeurreAnonymat>
              <td *ngIf="estRechercheOrganoleptique">{{ controle.numeroAnonymat}}</td>
            </ng-template>

            <!-- Colonne Laboratoire -->
            <td *ngIf="estRechercheAnalytique">{{ controle.libelleLaboratoire}}</td>

            <!-- Colonne Date envoi laboratoire -->
            <td *ngIf="estRechercheAnalytique">{{ controle.dateEnvoiLaboratoire | date:'dd/MM/yyyy'}}</td>

            <!-- Colonne Résultat -->
            <ng-container *ngIf="controle.isLeurre; else nonLeurreResultat">
              <td>
                <button type="button" class="btn btn-primary" (click)="onOpenEvaluationJure(controle)" translate>
                  <fa-icon icon="tasks"></fa-icon>
                  page.controles.controles.boutonEvaluation
                </button>
              </td>
            </ng-container>
            <ng-template #nonLeurreResultat>
              <td *ngIf="controle.statut?.code === 'TERMINE'">
                <span>{{ controle.nbManquement}} manquement(s)</span>
                <button type="button" class="btn btn-outline-secondary" (click)="onModifyControle(controle)" [ngbTooltip]="'Effacer le résultat'">
                  <fa-icon icon="eraser"></fa-icon>
                </button>
              </td>
              <td *ngIf="controle.statut?.code === 'EN_COURS' || controle.statut?.code === 'PREVU'" class="padding-top-15">
                <fa-icon icon="check-circle" title="Conforme" (click)="updateStatut(controle)" (keydown.enter)="updateStatut(controle)" class="green-icon">
                </fa-icon>
                <fa-icon icon="minus-circle" title="Non conforme" (click)="addConstat(controle)" (keydown.enter)="addConstat(controle)" class="red-icon">
                </fa-icon>
                <fa-icon icon="trash" title="Supprimer le contrôle" (click)="deleteControle(controle)" (keydown.enter)="deleteControle(controle)" class="blue-icon">
                </fa-icon>
              </td>
            </ng-template>

            <ng-template #listeCahier>
              <ul>
                <li *ngFor="let cahier of getLibelleCahier(controle)">{{ cahier }}</li>
              </ul>
            </ng-template>

            <ng-template #listeProduit>
              <ul>
                <li *ngFor="let produit of getLibelleProduit(controle)">{{ produit }}</li>
              </ul>
            </ng-template>
          </tr>
        </tbody>
      </table>
      <div *ngIf="isResultat && controles?.length === 0" class="alert alert-warning alert-block" translate>
        <fa-icon icon="exclamation"></fa-icon>
        page.controles.controles.search.aucunControle
      </div>
      <app-pagination-bar [pagination]="pagination"></app-pagination-bar>
    </ng-container>
  </div>
</div>

<ng-template #aucunDroits>
  <div class="alert alert-warning alert-block" translate>
    <fa-icon icon="exclamation"></fa-icon>
    page.controles.controles.search.aucunDroits
  </div>
</ng-template>

